<template>
  <main>
    <Header></Header>

    <section v-if="qrCodeUrl" class="pay_container">
      <div class="pay_wrapper">
        <img style="width: 60px; height: 60px; margin-top: 20px;" src="/static/images/test/wxpay.png">

        <div class="title2">请打开 微信扫一扫 支付</div>
        <vue-qr :correctLevel="3" :text="qrCodeUrl" :size="200"></vue-qr>
        <div class="title2">课程名称：{{courseWrapper.course.name}} </div>
        <div class="title2">课程价格：<span class="merchant_lower_price">￥{{courseWrapper.course.realPrice}}</span></div>
        <p class="pay_tips"><i class="el-icon-info"></i> 请在15分钟内完成支付 {{countdown}}</p>
        <p class="pay_tips"><i class="el-icon-info"></i> 支付完成后会跳转到支付成功页面，也会发送支付成功短信</p>
      </div>
    </section>

    <Footer></Footer>
  </main>
</template>

<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import {mapState, mapGetters} from 'vuex'
import VueQr from 'vue-qr'

import {
  reqCheckPayStatus
} from '@/api'

export default {
  name: 'Pay',
  components: {Header, Footer, VueQr},
  comments: {
    Header
  },

  data() {
    return {
      qrCodeUrl: '',
      timesRun: 0,
      interval: {},
      intervalCleaned: false,

      computeTimeInterval: {},
      computeTimeIntervalCleaned: false,
      computeTime: 0, // 15分钟
      computeTimeStr: ''
    }
  },

  async mounted () {
    if (!this.isLogin || !this.payInfo || !this.courseWrapper.course) {
      await this.$router.push('/')
      return
    }

    this.qrCodeUrl = this.payInfo.codeUrl
    let that = this

    // 每3秒发起一次查询
    that.interval = setInterval(async () => {
      that.timesRun += 1;
      if(that.timesRun >= 900){
        that.intervalCleaned = true
        clearInterval(that.interval)
        await this.$alert("支付超时，请重新购买", '提示', {
          confirmButtonText: '确定',
          callback: action => {
            that.$router.replace('/')
          }
        })
      }

      const result = await reqCheckPayStatus(this.payInfo.orderNo)

      if (result.code === 0) {
        if (result.data.payStatus === 1) {
          that.intervalCleaned = true
          clearInterval(that.interval)
          await this.$router.replace('/payConfirm')
        } else if (result.data.payStatus === 2) {
          that.intervalCleaned = true
          clearInterval(that.interval)

          await this.$alert("支付失败，请稍后重新购买", '提示', {
            confirmButtonText: '确定',
            callback: action => {
              that.$router.replace('/')
            }
          })
        }
      } else {
        that.intervalCleaned = true
        clearInterval(that.interval)
        await this.$alert("系统异常，请稍后重新购买", '提示', {
          confirmButtonText: '确定',
          callback: action => {
            that.$router.replace('/')
          }
        })
      }
    }, 3000);


    // 支付时间倒计时
    if (!this.computeTime) {
      this.computeTime = 900
      that.computeTimeInterval = setInterval(() => {
        that.computeTime--
        if (that.computeTime <= 0) {
          that.computeTimeIntervalCleaned = true
          clearInterval(that.computeTimeInterval)
        }
      }, 1000)
    }
  },

  methods: {

  },

  computed: {
    ...mapState(['courseWrapper', 'phone', 'payInfo']),
    ...mapGetters(['isLogin']),
    countdown: function () {
      const min = Math.ceil(this.computeTime / 60)
      const sec = Math.ceil(this.computeTime % 60)
      let strMin = min + ''
      if (min < 10) {
        strMin = '0' + min
      }
      let strSec = sec + ''
      if (sec < 10) {
        strSec = '0' + sec
      }
      return strMin + ":" + strSec
    }
  },

  beforeDestroy () {
    if (!this.intervalCleaned) {
      this.intervalCleaned = true
      clearInterval(this.interval)
    }
    if (!this.computeTimeIntervalCleaned) {
      this.computeTimeIntervalCleaned = true
      clearInterval(this.computeTimeInterval)
    }
  }
}
</script>

<style scoped>

  main {
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    background: #eee;
  }


  .pay_container {
    display: flex;
    flex-direction: column;
    width: 100%;
    background: #eee;
  }

  .pay_wrapper {
    width: 900px;
    margin: 10px auto;
    background: #fff;
    flex-direction: column;
    padding: 0 20px;
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .pay_wrapper > img {
    width: 300px;
    height: 300px;
  }

  .pay_tips {
    font-size: 12px;
    color: #999;
  }

  .title1 {
    /*line-height: 40px;*/
    margin-top: 20px;
    font-size: 24px;
    font-weight: 500;
    color: #333;
  }

  .title2 {
    /*line-height: 40px;*/
    margin: 20px 0;
    font-size: 18px;
    color: #333;
  }

  .merchant_lower_price {
    font-size: 20px;
    color: #CC0033;
    font-weight: bold;
  }

  .link {
    cursor: pointer;
    color: cornflowerblue;
  }

  .link:hover {
    color: #FF9900;
  }

</style>



// WEBPACK FOOTER //
// src/pages/Pay/Pay.vue